import { render, staticRenderFns } from "./BacHr.vue?vue&type=template&id=0c90fca7&scoped=true&"
var script = {}
import style0 from "./BacHr.vue?vue&type=style&index=0&id=0c90fca7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c90fca7",
  null
  
)

export default component.exports